/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilityrequest2Inputs */

const en_eventvisibilityrequest2 = /** @type {(inputs: Eventvisibilityrequest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On request`)
};

const de_eventvisibilityrequest2 = /** @type {(inputs: Eventvisibilityrequest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Anfrage`)
};

/**
* | output |
* | --- |
* | "On request" |
*
* @param {Eventvisibilityrequest2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilityrequest2 = /** @type {((inputs?: Eventvisibilityrequest2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilityrequest2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilityrequest2(inputs)
	return de_eventvisibilityrequest2(inputs)
});
export { eventvisibilityrequest2 as "eventVisibilityRequest" }